import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Reset native scroll immediately (before paint)
    window.scrollTo(0, 0);
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;

    // Lenis manages the smooth scroll position — reset it too, instantly
    const lenis = window.__lenis;
    if (lenis) {
      lenis.scrollTo(0, { immediate: true, force: true });
      // Second pass after the frame settles, in case content height changed
      requestAnimationFrame(() => lenis.scrollTo(0, { immediate: true, force: true }));
    }
  }, [pathname]);

  return null;
};
